import autocomplete from "autocompleter/autocomplete";

export default class SearchBox {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.search-box'), el => {
			new SearchBox(el);
		});
	}

	static applyAutocomplete(form) {
		if (!form.getAttribute('data-autocomplete-uri')) {
			return;
		}

		// Autocomplete doesn't expose the text and items, so we need to keep
		// a reference our self for instant updating
		const localCache = [];
		let items = [];
		let fetchingCounter = 0;
		let latestTextToFetch = '';

		const showTextAsFirstEntry = (items, text) => {
			if (!items || !items.length) {
				return [];
			}

			let firstSuggestionIsText = items[0].toLowerCase() === text.toLowerCase();
			return firstSuggestionIsText ? items : [text].concat(items);
		};

		const highlight = (text, value) => {
			if (text === undefined) return;
			let index = text.toLowerCase().indexOf(value.toLowerCase());
			if (index >= 0) {
				text = `${text.substring(0, index)}<span class='highlight'>${text.substring(index, index + value.length)}</span>${text.substring(index + value.length)}`;
			}

			return text;
		}

		new autocomplete({
			input: form.querySelector('input'),
			className: 'search-form__suggestions',
			minLength: 3,
			debounceWaitMs: 100,
			showOnFocus: true,
			//emptyMsg: 'No elements found',
			preventSubmit: false,
			renderGroup: function (groupName, currentValue) {
				let ul = document.createElement("UL");
				ul.textContent = groupName;
				return ul;
			},
			render: function (item, currentValue) {
				if (!item) return null;
				let li = document.createElement('LI');
				li.innerHTML = '' + highlight(item, currentValue);
				return li;
			},
			fetch: function (text, update) {
                latestTextToFetch = text;
				if (!text) {
					items = [];
					update(items);
					return;
				}

				fetchingCounter++;
				if (localCache[text]) {
					items = localCache[text];
					if (!Array.isArray(items)) {
						console.error('Cached item for ' + text + ' is invalid:');
						console.error(items);
					} else {
						update(items);
						return;
					}
				}

				// get new suggestions from the server
				//console.info('fetching suggestion for ' + text);
				let myFetchingCounter = fetchingCounter;
				fetch(form.getAttribute('data-autocomplete-uri') + '&term=' + encodeURIComponent(text))
					.then(response => response.json())
					.then(result => {
						if (myFetchingCounter === fetchingCounter) {
							items = showTextAsFirstEntry(result.completions, text);
							localCache[text] = items;
							update(items);
						}
					});
			},
			onSelect: function (text, input) {
                // if the latest fetch is not finished, we want to use the current input value
                // instead of the first auto-complete result, if the first result is selected
                let listIsUpToDate = items.length === 0 || latestTextToFetch === items[0];
                let firstResultIsSelected = text === items[0];

                if(listIsUpToDate || !firstResultIsSelected) {
                    // the selected option can be trusted, apply it
					input.value = text;
					input.dispatchEvent(new Event('autocomplete-select'));
				}

				if (form.hasAttribute('data-submit-on-change')) {
					form.submit();
				}
			},
			customize: (input, inputRect, container, maxHeight) => {
				if (input.closest('.header--fixed')) {
					container.classList.add('search-form__suggestions--is-fixed');
				}
			}
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.tooltip = element.querySelector('.field__tooltip');

		SearchBox.applyAutocomplete(element);

		this.input = element.querySelector('input');

		this.input.addEventListener('input', e => {
			let value = e.target.value;

			if (this.isDateInString(value)) {
				this.tooltip.querySelector('span').innerHTML = this.isDateInString(value);
				this.showTooltip();
			} else {
				this.hideTooltip();
			}
		});
	}

	showTooltip() {
		this.tooltip.classList.remove('field__tooltip--is-hidden');
	}

	hideTooltip() {
		this.tooltip.classList.add('field__tooltip--is-hidden');
	}

	isDateInString(str) {
		let substr;

		let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

		let match = '';
		let matchSrt = '';

		months.forEach(month => {
			if (str.toLowerCase().indexOf(month.toLowerCase()) >= 0) match = month;
		});

		let dateSlash = new RegExp(/^\d{2}\/\d{2}/gi);
		let dateDot = new RegExp(/^\d{2}.\d{2}/gi);
		let dateMinus = new RegExp(/^\d{2}-\d{2}/gi);
		let dateColon = new RegExp(/^\d{2}:\d{2}/gi);

		matchSrt = match.length ? match : (str.match(dateSlash) !== null) ? str.match(dateSlash)[0] : (str.match(dateDot) !== null) ? str.match(dateDot)[0] : (str.match(dateMinus) !== null) ? str.match(dateMinus)[0] : (str.match(dateColon) !== null) ? str.match(dateColon)[0] : '';

		return matchSrt;
	}
}
